module.exports = __webpack_public_path__ + "static/media/documentation.ef7b52c1.md";